
import { Component, Vue } from 'vue-property-decorator'
import AddLabel from '@/views/goodsManage/commodity/template/AddLabel.vue'
import { getGoodsTagList, GoodsTagListDto } from "@/api/commodity";
Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    AddLabel
  }
})
export default class ChooseCustomer extends Vue {
  $refs!: {
    addLabel: AddLabel
  }
  showTemp = false
  tagList: GoodsTagListDto[] | Record<string, any> = []
  companyId = ''
  tagId: string[] = []
  currTag: GoodsTagListDto[] = []
  isRefresh = 0
  btnType = 'cancel'
  visible = false

  created () {
    this.getbrandList()
  }
  beforeRouteLeave (to, from, next) {
    to.query.isRefresh = this.isRefresh
    if (this.btnType === 'save') {
      to.query.currTag = this.currTag
    }
    next();
  }

  handleBack () {
    this.$eventBus.$emit('currentPage', 1)
    this.visible = false
  }

  handleHomeBack () {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '现在退出则不会保存已修改内容，是否确认退出?',
      onOk: () => {
        this.$goHomeBack()
      },
    })
  }

  showModal (goodsTagIdList: string[]) {
    this.tagId = []
    this.currTag = []
    this.visible = true
    this.tagList.forEach(item => {
      if (goodsTagIdList.includes(item.tagId)) {
        this.changeTag(item)
      }
    })
  }

  getbrandList () {
    const params = {
      pageIndex: 1,
      pageSize: 999,
      isPage: false
    }
    getGoodsTagList(params).then((res) => {
      this.tagList = res.data || []
    })
  }
  show (option: { companyId: string, tagId: string }) {
    this.companyId = option.companyId
    // this.tagId = option.tagId
    this.getbrandList()

  }
  toAdd () {
    // this.$router.push({
    //   path:'/AddLabel',
    //   query:{
    //     companyId: this.companyId
    //   }
    // })
    this.$refs.addLabel.showModal()
  }
  changeTag (tag: GoodsTagListDto) {
    if (!this.tagId.includes(tag.tagId)) {
      if (this.tagId.length >= 4) return false
      this.tagId.push(tag.tagId)
      this.currTag.push(tag)
    } else {
      const index = this.tagId.indexOf(tag.tagId)
      this.tagId.splice(index, 1)
      this.currTag.splice(index, 1)
    }
  }
  handleSave () {
    this.btnType = 'save'
    // this.$router.back()
    this.$emit('on-save', this.currTag)
    this.handleBack()
  }
}
